/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 電気契約値情報
 */
export interface Szma103aResponseElecCtrSearchResultDtoElecConvalMstInfo {
    /**
     * 契約電流：英数字<br>　コード変換マスターテーブル.画面項目ID「C401120」のユーザコードを設定
     */
    conAmpA?: string;
    /**
     * 契約電流名称：全半角混在
     */
    conAmpAAname?: string;
    /**
     * 契約容量
     */
    conCapKva?: number;
    /**
     * 契約電力
     */
    conEleKw?: number;
    /**
     * 電灯数（１０Ｗまで）
     */
    lgt0ov10?: number;
    /**
     * 電灯数（１０Ｗから２０Ｗまで）
     */
    lgt10ov20?: number;
    /**
     * 電灯数（２０Ｗから４０Ｗまで）
     */
    lgt20ov40?: number;
    /**
     * 電灯数（４０Ｗから６０Ｗまで）
     */
    lgt40ov60?: number;
    /**
     * 電灯数（６０Ｗから１００Ｗまで）
     */
    lgt60ov100?: number;
    /**
     * 電灯数（１００Ｗから２００Ｗまで）
     */
    lgt100Ov?: number;
    /**
     * 電灯数（２００Ｗから３００Ｗまで）
     */
    lgt200Ov?: number;
    /**
     * 電灯数（３００Ｗ超過）
     */
    lgt300Ov?: number;
    /**
     * 小型機器数（５０ＶＡまで）
     */
    eqp0ov50?: number;
    /**
     * 小型機器数（５０ＶＡから１００ＶＡまで）
     */
    eqp50ov100?: number;
    /**
     * 小型機器数（１００ＶＡから２００ＶＡまで）
     */
    eqp100Ov?: number;
    /**
     * 小型機器数（２００ＶＡから３００ＶＡまで）
     */
    eqp200Ov?: number;
    /**
     * 小型機器数（３００ＶＡ超過）
     */
    eqp300Ov?: number;
    /**
     * ３０分値収集可否：英数字<br>　コード変換マスターテーブル.画面項目ID「C401130」のユーザコードを設定
     */
    mclc30Flg?: string;
    /**
     * ３０分値収集可否名称：全半角混在
     */
    mclc30FlgAname?: string;
    /**
     * 再エネ賦課金減免有無：英数字<br>　コード変換マスターテーブル.画面項目ID「C401140」のユーザコードを設定
     */
    redtaxFlg?: string;
    /**
     * 再エネ賦課金減免有無名称：全半角混在
     */
    redtaxFlgAname?: string;
    /**
     * 再エネ賦課金減免率：英数字<br>　コード変換マスターテーブル.画面項目ID「C401150」のユーザコードを設定
     */
    redtaxPrcnt?: string;
    /**
     * 再エネ賦課金減免率名称：全半角混在
     */
    redtaxPrcntAname?: string;
    /**
     * 再エネ賦課金減免開始日：日付(yyyyMMdd)
     */
    redStrtDate?: string;
    /**
     * 再エネ賦課金減免終了日：日付(yyyyMMdd)
     */
    redEndDate?: string;
    /**
     * 予備線供給電圧：英数字<br>　コード変換マスターテーブル.画面項目ID「C021071」のユーザコードを設定
     */
    slVltdiv?: string;
    /**
     * 予備線供給電圧名称：全半角混在
     */
    slVltdivAname?: string;
    /**
     * 予備電源供給電圧：英数字<br>　コード変換マスターテーブル.画面項目ID「C021071」のユーザコードを設定
     */
    sepVltdiv?: string;
    /**
     * 予備電源供給電圧名称：全半角混在
     */
    sepVltdivAname?: string;
}

